import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=1c76f17c&scoped=true&"
import script from "./StaffManagement.vue?vue&type=script&lang=ts&"
export * from "./StaffManagement.vue?vue&type=script&lang=ts&"
import style0 from "./StaffManagement.vue?vue&type=style&index=0&id=1c76f17c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76f17c",
  null
  
)

export default component.exports